<!-- Screen Reader will announce dynamic change of document title -->
@if (pageTitle) {
  <div aria-live="assertive">
    <span [attr.aria-label]="pageTitle"></span>
  </div>
}

<app-error></app-error>
<router-outlet></router-outlet>
<app-loader></app-loader>
